import { render, staticRenderFns } from "./Advisors.vue?vue&type=template&id=43b05446"
import script from "./Advisors.vue?vue&type=script&lang=js"
export * from "./Advisors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports